import { createSlice, configureStore } from '@reduxjs/toolkit';
import PopUpModal from '../components/PopUpModal/PopUpModal';
import Product from '../components/Product/Product';

const initialVisualizerState = { 
    surfaceList : [],
    selectedSurface: {type:"FLOOR"},
    specifier:"",
    selString:"",

    productDataBySeries:{},
    productDropdownFilters:{},
    productSearchFilters:{},

    flooringTypeFilterObj:{},
    flooringTypes:{},
    flooringColors:{},
    sampleCart:{},

    shareData:{
      specifier:"",
      sel:-1,
      url:"",
      message:"Check out this design I made using the Southern Luxe Visualizer!"
  }

};

const visualizerSlice = createSlice({
  name: 'visualizer',
  initialState: initialVisualizerState,

  loadBackup(state, actions){
    state.surfaceList = actions.payload.surfaceList;
    state.selectedSurface = actions.payload.selectedSurface;
    state.specifier = actions.payload.specifier;
    state.selString = actions.payload.selString;
    state.productDataBySeries = actions.payload.productDataBySeries;
    state.productSearchFilters = actions.payload.productSearchFilters;
    state.flooringTypeFilterObj = actions.payload.flooringTypeFilterObj;
    state.flooringTypes = actions.payload.flooringTypes;
    state.flooringColors = actions.payload.flooringColors;
    state.sampleCart = actions.payload.sampleCart;
  },

  reducers: {
    setSurfaceList(state,action) {
      state.surfaceList = action.payload;
    },
    setSelectedSurface(state,action){
      state.selectedSurface = action.payload;
    },
    setSpecifier(state,action){
      state.specifier = action.payload;
    },
    setSelString(state,action){
      state.selString = action.payload;
    },

    setProductDataBySeries(state, action){
      state.productDataBySeries[action.payload.seriesId] = action.payload.data;
    },

    setflooringTypes(state, action){
      state.flooringTypes = action.payload;
    },
    setflooringColors(state, action){
      state.flooringColors = action.payload;
    },

    setproductDropdownFilter(state, action) {
      state.productDropdownFilters = {
          ...state.productDropdownFilters, // preserve existing
          ...action.payload, // merge new filter
      };
    },

    setflooringTypeFilterObj(state, action){
      state.flooringTypeFilterObj = action.payload;
    },
    
    
    clearProductDropdownFilters(state, action) {
      const keepIndexes = action.payload;
      //remove any by index and exclude any indexes in keepIndexes
      state.productDropdownFilters = Object.keys(state.productDropdownFilters)
          .filter(key => keepIndexes.includes(key))
          .reduce((filtered, key) => {
              filtered[key] = state.productDropdownFilters[key];
              return filtered;
          }, {});
    },
  
  

    setProductSearchFilter(state, action) {
      state.productSearchFilters = {
          ...state.productSearchFilters, // preserve existing
          ...action.payload, // merge new filter
      };
    },

    clearProductSearchFilters(state, action){
      state.productSearchFilters = {};
    },

    addToSampleCart(state, action) {
      const { key, data } = action.payload;
  
      if (!state.sampleCart.hasOwnProperty(key)) {
          state.sampleCart[key] = data; 
      }
    },

    removeFromSampleCart(state, action) {
      const { key } = action.payload;
      if (state.sampleCart.hasOwnProperty(key)) {
          delete state.sampleCart[key];
      }
    },
  
  
    clearSampleCart(state, action){
      state.sampleCart = {};
    },

    // Set share data to be used from social share options & email
    setShareData(state,action){
      state.shareData = action.payload;
    }


  },
});


const initialUIState = {
  toolName:"React Base Tool",
  vizLoading: false,
  popUpModalActive : false,
  shareModalActive : false,
  emailModalActive : false,
  sampleCartModalActive:false,
  socialShareText : "Checkout this design I made using the React Base Tool Visualizer!",
};

const uiSlice = createSlice({
  name: 'ui',
  initialState: initialUIState,
  reducers: {
    setToolName(state, action) {
      state.toolName = action.payload;
    },
    setVizLoading(state, action) {
      state.vizLoading = action.payload;
    },
    setShareModalActive(state, action){
      state.shareModalActive = action.payload;
    },
    setPopUpModalActive(state, action){
      state.popUpModalActive = action.payload;
    },
    setEmailModalActive(state, action){
      state.emailModalActive = action.payload;
    },
    setSampleCartModalActive(state, action){
      state.sampleCartModalActive = action.payload;
    },
    setPopUpModalStatus(state, action){
      state.showPopUpModal = action.payload;
    },
    setEmailShareModalStatus(state, action){
      state.showEmailShareModal = action.payload;
    },
    setFeedbackModalActive(state, action){
      state.feedbackModalActive = action.payload;
    },
    setHelpModalActive(state, action){
      state.helpModalActive = action.payload;
    },

  },
});


const store = configureStore({
  reducer: {
    visualizer: visualizerSlice.reducer,
    ui: uiSlice.reducer
  }
});

export const visualizerActions = visualizerSlice.actions;
export const uiActions = uiSlice.actions;

export default store;